// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"AppContainer_appContainer__2Hm98"};